import { render, staticRenderFns } from "./MagicLink.vue?vue&type=template&id=710492da&scoped=true&"
import script from "./MagicLink.vue?vue&type=script&lang=ts&"
export * from "./MagicLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710492da",
  null
  
)

export default component.exports